import type { FC } from "react";
import { useMemo } from "react";

import { DateTime } from "luxon";

import type { MessageTimestamp } from "shared/types";
import { Text } from "shared/uikit";
import { TextVariantsEnum } from "shared/uikit/types";

import { getDateTime } from "utils/getDateTime";

interface TimeBaseProps {
	time?: DateTime | Date | MessageTimestamp | string | number | null;
}

const TimeBase: FC<TimeBaseProps> = ({ time }) => {
	const timeString = useMemo(() => {
		if (time) {
			const luxonTime = getDateTime(time);
			return luxonTime.toLocaleString(DateTime.TIME_SIMPLE);
		}
		return "";
	}, [time]);

	return <Text variants={TextVariantsEnum.INHERIT_SPAN}>{timeString}</Text>;
};

export default TimeBase;
